import { render, staticRenderFns } from "./SetExercise.vue?vue&type=template&id=b7aba21a&"
import script from "./SetExercise.vue?vue&type=script&lang=js&"
export * from "./SetExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports